module.exports = __webpack_public_path__ + "img/oj-logo-mobile.dd50392e.png";